module.exports = __webpack_public_path__ + "img/ep-P.24708041.jpg";